// extracted by mini-css-extract-plugin
module.exports = {"outterCategoryContainer":"CategoryItemList_outterCategoryContainer__1G9u7"};